import { ToastError, ToastSuccess } from "components/Global/Toasts/Toasty";

import {
  amortizationTypes, bizDayAdjustmentReset, calculationAdjustment, currencyTypes, daycount, fixedIndices,
  floatingIndices, frequency, instrumentTypes, payOrReceive, paymentAdjustment, rateTypes, resetDayTypes, resetTypes,
  rounding, roundingConventions, stubPeriodTypes, whenPaymentOccurs, whenResetOccurs, resetFrequency, resetDay,
  legTypes, cashflowTypes, hedgeTypes
} from "./configItemValues";

export const validateCap = (cashflowParameters, legOneParameters, legTwoParameters, numberOfLegs) => {
  let isValid = true;
  if (cashflowParameters.notional === null) {
    ToastError("Please Enter a Notional Amount");
    isValid = false;
  }
  if (cashflowParameters.startDate === null) {
    ToastError("Please Enter a Start Date");
    isValid = false;
  }
  if (cashflowParameters.endDate === null) {
    ToastError("Please Enter a End Date");
    isValid = false;
  }
  if (legOneParameters.legType === null) {
    ToastError("Please select Leg One Leg Type");
    isValid = false;
  }
  if (legOneParameters.rateType === null) {
    ToastError("Please select Leg One Rate Type");
    isValid = false;
  }
  if (legOneParameters.index === null) {
    ToastError("Please select Leg One Index");
    isValid = false;
  }
  if (legOneParameters.rateType === rateTypes.Fixed && legOneParameters.rate === null) {
    ToastError("Please select Leg One Strike");
    isValid = false;
  }
  if (legOneParameters.rateType === rateTypes.Floating && legOneParameters.roundingConvention === null) {
    ToastError("Please select Leg One Rounding Convention");
    isValid = false;
  }
  if (legOneParameters.rateType === rateTypes.Floating && legOneParameters.roundingMethodology === null) {
    ToastError("Please select Leg One Rounding Methodology");
    isValid = false;
  }
  if (legOneParameters.daycount === null) {
    ToastError("Please select Leg One Daycount");
    isValid = false;
  }
  if (legOneParameters.resetType === null) {
    ToastError("Please select Leg One Reset Type");
    isValid = false;
  }
  if (legOneParameters.resetFrequency === null) {
    ToastError("Please select Leg One Reset Frequency");
    isValid = false;
  }
  if (legOneParameters.resetWeekDay === null) {
    ToastError("Please select Leg One Reset Week Day");
    isValid = false;
  }
  if (legOneParameters.daycount === null) {
    ToastError("Please select Leg One Daycount");
    isValid = false;
  }

  if (numberOfLegs.value === 2) {
    if (legTwoParameters.legType === null) {
      ToastError("Please select Leg Two Leg Type");
      isValid = false;
    }
    if (legTwoParameters.rateType === null) {
      ToastError("Please select Leg One Rate Type");
      isValid = false;
    }
    if (legTwoParameters.index === null) {
      ToastError("Please select Leg Two Index");
      isValid = false;
    }
    if (legTwoParameters.rate === null) {
      ToastError("Please select Leg Two Strike");
      isValid = false;
    }
    if (legTwoParameters.roundingConvention === null) {
      ToastError("Please select Leg Two Rounding Convention");
      isValid = false;
    }
    if (legTwoParameters.roundingMethodology === null) {
      ToastError("Please select Leg Two Rounding Methodology");
      isValid = false;
    }
    if (legTwoParameters.daycount === null) {
      ToastError("Please select Leg Two Daycount");
      isValid = false;
    }
    if (legTwoParameters.resetType === null) {
      ToastError("Please select Leg Two Reset Type");
      isValid = false;
    }
    if (legTwoParameters.resetFrequency === null) {
      ToastError("Please select Leg Two Reset Frequency");
      isValid = false;
    }
    if (legTwoParameters.resetWeekDay === null) {
      ToastError("Please select Leg Two Reset Week Day");
      isValid = false;
    }
    if (legTwoParameters.daycount === null) {
      ToastError("Please select Leg Two Daycount");
      isValid = false;
    }
    if (legOneParameters.legType === legTwoParameters.legType) {
      ToastError("Legs cannot be the same type");
      isValid = false;
    }
  }

  return isValid;
};
